// import { parseFullSymbol } from './helper.js';
// import { socketio } from 'socket.io';

// const wsURL = "wss://chart.gudangkripto.id";
// const wsURL = "wss://wsv2.gudangkripto.id";
const wsURL = "wss://be.gudangkripto.id/ws";
// const wsURL = "ws://localhost:8081";
const socket = new WebSocket(wsURL);
const channelToSubscription = new Map();

const tvIntervals = {
  1: "1m",
  30: "30m",
  60: "1h",
  "1D": "1d",
  "3D": "3d",
  "1W": "1w",
  "1M": "1M",
};

let paramStr = "";

socket.onopen = (e) => {
  // console.info(`GKI WS Open`)
  localStorage.setItem("wsStatus", 1);
};

socket.onclose = () => {
  // console.warn('GKI WS Closed')
  localStorage.setItem("wsStatus", 0);
};

socket.onerror = (err) => {
  // console.warn('GKI WS Error', err)
  localStorage.setItem("wsStatus", 0);
};

socket.onmessage = (msg) => {
  if (!msg?.data) return;
  let sData = JSON.parse(msg.data);
  // console.log('[socket] Message:', sData)
  try {
    if (sData && sData.k) {
      // let { s } = sData;
      let { o, h, l, v, c, T, t } = sData.k;

      const subscriptionItem = channelToSubscription.get(paramStr);
      if (subscriptionItem === undefined) {
        return;
      }
      const lastDailyBar = subscriptionItem.lastDailyBar;
      const nextDailyBarTime = getNextDailyBarTime(lastDailyBar.time);

      let bar;
      if (t >= nextDailyBarTime) {
        bar = {
          time: nextDailyBarTime,
          close: parseFloat(c),
          open: parseFloat(o),
          high: parseFloat(h),
          low: parseFloat(l),
          volume: parseFloat(v),
          closeTime: T,
          openTime: t,
        };
        // console.log("[socket] Generate new bar", bar);
      } else {
        bar = {
          ...lastDailyBar,
          time: t,
          close: parseFloat(c),
          open: parseFloat(o),
          high: parseFloat(h),
          low: parseFloat(l),
          volume: parseFloat(v),
          closeTime: T,
          openTime: t,
        };
        // console.log(
        //   "[socket] Update the latest bar by price",
        //   JSON.stringify(bar)
        // );
      }
      subscriptionItem.lastDailyBar = bar;
      // Send data to every subscriber of that symbol
      subscriptionItem.handlers.forEach((handler) => handler.callback(bar));
    }
  } catch (err) {
    // console.warn("GKI WS Message Error", err);
  }
};

export function subscribeOnStream(
  symbolInfo,
  resolution,
  onRealtimeCallback,
  subscriberUID,
  onResetCacheNeededCallback,
  lastDailyBar
) {
  // let symbolName =
  //   symbolInfo.name.toLowerCase().substr(-3) === "idr"
  //     ? symbolInfo.name
  //         .toLowerCase()
  //         .substr(0, symbolInfo.name.toLowerCase().length - 3)
  //     : symbolInfo.name.toLowerCase();
  // paramStr = `${symbolName}@kline_${tvIntervals[resolution]}`;
  // const obj = {
  //   // method: "SUBSCRIBE",
  //   method: "SUBSCRIBE-" + symbolName + "-" + tvIntervals[resolution],
  //   params: [paramStr],
  //   id: 1,
  // };
  // console.log(onResetCacheNeededCallback);
  // console.log("[subscribeBars]: " + socket.readyState);
  
  const fiat = symbolInfo.name.includes('IDR') ? symbolInfo.name.slice(-3) : symbolInfo.name.slice(-4)
  const coin = symbolInfo.name.replace(fiat, '')
  const obj = {
    action: 'subscribe',
    channels: [`market:kline:${coin}_${fiat}:${tvIntervals[resolution]}`]
  }

  if (socket.readyState === 1) {
    socket.send(JSON.stringify(obj));
    const handler = {
      id: subscriberUID,
      callback: onRealtimeCallback,
    };
    let subscriptionItem = channelToSubscription.get(paramStr);
    if (subscriptionItem) {
      // Already subscribed to the channel, use the existing subscription
      subscriptionItem.handlers.push(handler);
      return;
    }
    subscriptionItem = {
      subscriberUID,
      resolution,
      lastDailyBar,
      handlers: [handler],
    };
    channelToSubscription.set(paramStr, subscriptionItem);
    // console.log("[subscribeBars]: Subscribe to streaming. Channel:", paramStr);
  } else {
    // console.log("[subscribeBars]: Subscribe to streaming. ID:", subscriberUID);
  }
}

export function unsubscribeFromStream(subscriberUID) {
  try {
    // Find a subscription with id === subscriberUID
    for (const paramStr of channelToSubscription.keys()) {
      const subscriptionItem = channelToSubscription.get(paramStr);
      const handlerIndex = subscriptionItem.handlers.findIndex(
        (handler) => handler.id === subscriberUID
      );

      if (handlerIndex !== -1) {
        // Remove from handlers
        subscriptionItem.handlers.splice(handlerIndex, 1);

        if (subscriptionItem.handlers.length === 0) {
          // Unsubscribe from the channel if it is the last handler
          // console.log(
          //   "[unsubscribeBars]: Unsubscribe from streaming. Channel:",
          //   paramStr
          // );
          const obj = {
            method: "UNSUBSCRIBE",
            params: [paramStr],
            id: 1,
          };
          if (socket.readyState === 1) {
            socket.send(JSON.stringify(obj));
          }
          channelToSubscription.delete(paramStr);
          break;
        }
      }
    }
  } catch (err) {
    // console.log("[unsubscribeBars]: error:", err);
  }
}

function getNextDailyBarTime(barTime) {
  const date = new Date(barTime * 1000);
  date.setDate(date.getDate() + 1);
  return date.getTime() / 1000;
}
